var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_19117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7879 16.2252C25.7879 15.5668 25.7296 14.9418 25.6296 14.3335H16.2129V18.0918H21.6046C21.3629 19.3252 20.6546 20.3668 19.6046 21.0752V23.5752H22.8212C24.7046 21.8335 25.7879 19.2668 25.7879 16.2252Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2131 25.9999C18.9131 25.9999 21.1714 25.0999 22.8214 23.5749L19.6048 21.0749C18.7048 21.6749 17.5631 22.0415 16.2131 22.0415C13.6048 22.0415 11.3964 20.2832 10.6048 17.9082H7.28809V20.4832C8.92975 23.7499 12.3048 25.9999 16.2131 25.9999Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6046 17.9083C10.3962 17.3083 10.2879 16.6666 10.2879 15.9999C10.2879 15.3333 10.4046 14.6916 10.6046 14.0916V11.5166H7.28789C6.60456 12.8666 6.21289 14.3833 6.21289 15.9999C6.21289 17.6166 6.60456 19.1333 7.28789 20.4833L10.6046 17.9083Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2131 9.95833C17.6881 9.95833 19.0048 10.4667 20.0464 11.4583L22.8964 8.60833C21.1714 6.99167 18.9131 6 16.2131 6C12.3048 6 8.92975 8.25 7.28809 11.5167L10.6048 14.0917C11.3964 11.7167 13.6048 9.95833 16.2131 9.95833Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_19117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.82d5da143be5d9edf94b19a4792c5978.svg";
export { ForwardRef as ReactComponent };